<template>
    <div id="event-group">
        <div class="row topactionform smallmargin">
            <div class="col-xs-4">
                <div class="smalltitle">Event Billing Settled</div>
            </div>

            <div class="col-xs-8">
                <form class="onelineform flowsearch" @submit.prevent="submitSearchBill">
                    <input type="text" placeholder="Vendor name, user name"
                           v-model="formSearch.keySearch"
                           class="keyinput" style="width: 58% !important;">
                    <date-picker v-model="formSearch.fromDate"
                                 placeholder="From" title="Filter by Date of Service"
                                 format="MM/DD/YYYY"
                                 :clearable="true"
                                 :append-to-body=true
                                 lang="en" style="float: none !important;">
                    </date-picker>

                    <date-picker v-model="formSearch.toDate"
                                 placeholder="To" title="Filter by Date of Service"
                                 :append-to-body=true
                                 format="MM/DD/YYYY" class="testdate"
                                 lang="en" style="float: none !important;"></date-picker>
                    <button style="width: 8%;   border-left: 1px solid #e1e1e1 !important;" type="submit"
                            class="submit btn light"><i class="fa fa-search"></i>
                    </button>
                </form>
            </div>
        </div>

        <!--<ul class="itemlisttable flowlisttype messageflow">-->
            <!--<li class="itemlisthead">-->
                <!--<div style="width: 35% !important;">Attendant</div>-->
                <!--<div style="width: 35% !important;">Event</div>-->
                <!--<div style="width: 10% !important;">Group</div>-->
                <!--<div style="width: 10% !important;">Date</div>-->
                <!--<div style="width: 9% !important; text-align: right !important;">Amount</div>-->
            <!--</li>-->
            <!--<li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt">-->
                <!--<i class="fas fa-spinner fa-spin"></i>-->
            <!--</li>-->
            <!--<li v-if="!isLoading && dataEvents.length === 0" style="text-align: center; font-size: 16pt">No records-->
                <!--found-->
            <!--</li>-->
            <!--<li v-if="!isLoading" v-for="(event, index) in dataEvents" @click.prevent="showDetail(event)">-->
                <!--<div style="width: 35% !important;">{{ event.memberName }}</div>-->
                <!--<div style="width: 35% !important;" :title="event.title_event">{{ event.title_event }}</div>-->
                <!--<div style="width: 10% !important; min-height: 1px !important;">{{ event.groupName }}</div>-->
                <!--<div style="width: 10% !important;">{{ formatFullTime(event.paymentRequest_paid_date) }}</div>-->
                <!--<div style="width: 9% !important; text-align: right !important;">{{ formatStringToView(event.amount)-->
                    <!--}}-->
                <!--</div>-->
            <!--</li>-->
        <!--</ul>-->

        <ul class="itemlisttable flowlisttype messageflow">
            <li class="itemlisthead">
                <div class="item-select"><input type="checkbox"></div>
                <div class="item-date">Date</div>
                <div class="item-type">Type</div>
                <div class="item-bill">Bill Number</div>
                <div class="item-vendor">Vendor</div>
                <div class="item-user">User</div>
                <div class="item-description">Description</div>
                <div class="item-itemized">Itemized ticket</div>
                <div class="item-amount">Amount</div>
                <div class="item-status">Status</div>
                <div class="item-payment">Payment</div>
                <div class="item-action itemaction"></div>
            </li>
            <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt">
                <i class="fas fa-spinner fa-spin"></i>
            </li>
            <li v-if="!isLoading && dataEvents.length === 0" style="text-align: center; font-size: 16pt">No records
                found
            </li>
            <!--<li v-if="!isLoading" v-for="(event, index) in dataEvents" >-->
                <!--<div class="item-select">-->
                    <!--<input type="checkbox" >-->
                <!--</div>-->
                <!--<div class="item-date"  @click.prevent="showDetail(event)">-->
                    <!--<span>{{ formatTime(event.paidDate)}}</span>-->
                    <!--<span style="display: block">{{ formatOnlyTime12Hour(event.paidDate)}}</span>-->
                <!--</div>-->
                <!--<div class="item-type"  @click.prevent="showDetail(event)">Event</div>-->
                <!--<div class="item-bill"  @click.prevent="showDetail(event)">#{{ event.id }}</div>-->
                <!--<div class="item-vendor"  @click.prevent="showDetail(event)"><b>{{ event.groupName }}</b></div>-->
                <!--<div class="item-user"  @click.prevent="showDetail(event)">{{event.memberName}}</div>-->
                <!--<div class="item-description"  @click.prevent="showDetail(event)">{{event.title}}</div>-->
                <!--<div class="item-itemized"  @click.prevent="showDetail(event)">-->
                    <!--<ul class="itemsublist billing-icd" v-if="event.categorySponsor">-->
                        <!--<li>-->
                            <!--<span>{{ event.categorySponsor}}: {{ formatStringToView(event.total_ticket) }}</span>-->
                        <!--</li>-->
                        <!--&lt;!&ndash;<li>&ndash;&gt;-->
                            <!--&lt;!&ndash;<span>Exhibitors: {{ formatStringToView(event.amount - event.total_ticket) }}</span>&ndash;&gt;-->
                        <!--&lt;!&ndash;</li>&ndash;&gt;-->
                    <!--</ul>-->
                    <!--<ul class="itemsublist billing-icd">-->
                        <!--<li v-if="event.ticketName">-->
                            <!--<span>{{ event.ticketName}}: {{ formatStringToView(event.total_ticket) }}</span>-->
                        <!--</li>-->
                        <!--<li v-if="event.hotel">-->
                            <!--<span>{{ event.hotel }}: {{ formatStringToView(event.price_hotel) }}</span>-->
                        <!--</li>-->
                        <!--<li v-if="event.addition_title">-->
                            <!--<span>{{ event.addition_title }}: {{ formatStringToView(event.addition_amount) }}</span>-->
                        <!--</li>-->
                        <!--<li v-if="event.addition_title_more">-->
                            <!--<span>{{ event.addition_title_more }}: {{ formatStringToView(event.addition_amount_more) }}</span>-->
                        <!--</li>-->
                    <!--</ul>-->

                <!--</div>-->
                <!--<div class="item-amount"  @click.prevent="showDetail(event)">{{ formatStringToView(event.amount) }}</div>-->
                <!--<div class="item-status"  @click.prevent="showDetail(event)" :title="event.transactionReasonError">{{event.transactionStatusText}}</div>-->
                <!--<div class="item-payment"></div>-->
                <!--<div class="item-action itemaction">-->
                    <!--<dropdown class="dropdown">-->
                        <!--<a href="javascript:void(0)" title="Choose action" data-toggle="dropdown"><i-->
                                <!--class="fa fa-cog"></i></a>-->
                        <!--<template slot="dropdown">-->

                        <!--</template>-->
                    <!--</dropdown>-->
                <!--</div>-->
            <!--</li>-->

            <li v-if="!isLoading" v-for="(event, index) in dataEvents">
                <div class="item-select"><input type="checkbox"></div>
                <div class="item-date">
                    <span>{{ formatTime(event.createdAt)}}</span>
                    <span style="display: block">{{ formatOnlyTime12Hour(event.createdAt)}}</span>
                </div>
                <div class="item-type">{{event.typeText}}</div>
                <div class="item-bill">#{{ event.id }}</div>
                <div class="item-vendor"><b>{{ event.vendorName }}</b></div>
                <div class="item-user">{{event.objectName}}</div>
                <div class="item-description">{{event.description}}</div>
                <div class="item-itemized">
                    <ul class="itemsublist billing-icd" v-if="event.itemDetails">
                        <li v-for="item in event.itemDetails">
                            <span>{{item.name}}</span>
                        </li>
                    </ul>
                </div>
                <div class="item-amount">{{ formatStringToView(event.amount) }}</div>
                <div class="item-status" >{{event.statusText}}</div>
                <div class="item-payment"></div>
                <div class="item-action itemaction">
                    <dropdown class="dropdown">
                        <a href="javascript:void(0)" title="Choose action" data-toggle="dropdown"><i
                                class="fa fa-cog"></i></a>
                        <template slot="dropdown">

                        </template>
                    </dropdown>
                </div>
            </li>
        </ul>
        <br/>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>

        <detail-ticket-event v-if="detailTicket.modal" :detailTicket="detailTicket.data"
                             @updateModal="detailTicket.modal = $event"></detail-ticket-event>
        <detail-ticket-sponsor v-if="detailSponsor.modal" :detailTicket="detailSponsor.data"
                               @updateModal="detailSponsor.modal = $event"></detail-ticket-sponsor>
    </div>
</template>

<script>
import axios from '../../client'
import Common from '../mixins/Common.vue'
import DetailTicketEvent from './part/DetailTicketEvent'
import DetailTicketSponsor from './part/DetailTicketSponsor'
import Pagination from '../../global/Pagination.vue'
import DatePicker from '../../global/datepicker/DatePickerCustom.vue'
import moment from 'moment'

export default {
  name: 'event-billing',
  components: { Pagination, DatePicker, DetailTicketEvent, DetailTicketSponsor },
  mixins: [Common],
  data () {
    return {
      key_search: '',
      isLoading: false,
      dataEvents: [],
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isGeneratingCode: false,
      postEventDate: '',
      endEventDate: '',
      formSearch: {
        keySearch: '',
        fromDate: moment().subtract(1, 'months'),
        toDate: moment()
      },
      detailTicket: {
        data: {},
        modal: false
      },
      detailSponsor: {
        data: {},
        modal: false
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    submitSearchBill () {
      this.paginate.page = 1
      this.loadData()
    },
    async loadDataBilling () {
      if (this.isLoading) {
        return true
      }
      try {
        let params = {
          page: this.paginate.page,
          perPage: this.paginate.perPage,
          key: this.formSearch.keySearch,
          fromDate: this.formSearch.fromDate ? moment(this.formSearch.fromDate).format('MM/DD/YYYY') : '',
          toDate: this.formSearch.toDate ? moment(this.formSearch.toDate).format('MM/DD/YYYY') : '',
          status: 1
        }
        let response = await axios.get('/billings/get-list', { params: params })
        this.isLoading = false
        if (response.data.s === 200) {
          this.dataEvents = response.data.data.bills
          this.paginate.total = Number(response.data.data.total)
          this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
        } else {
          this.dataEvents = []
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.isLoading = false
        this.alertError('Server error when load data. Press F5 to refresh browser')
      }
    },
    loadData () {
      return this.loadDataBilling()
      if (!this.isLoading) {
        let params = {
          page: this.paginate.page,
          perPage: this.paginate.perPage,
          key: this.formSearch.keySearch,
          fromDate: this.formSearch.fromDate ? moment(this.formSearch.fromDate).format('MM/DD/YYYY') : '',
          toDate: this.formSearch.toDate ? moment(this.formSearch.toDate).format('MM/DD/YYYY') : '',
          status: 1
        }
        this.isLoading = true
        axios.get(`events-billing/get-list`, { params: params }).then(response => {
          this.isLoading = false
          if (response.data.s === 200) {
            this.dataEvents = response.data.data.bills
            this.paginate.total = Number(response.data.data.total)
            this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
          } else {
            this.dataEvents = []
            this.alertError(response.data.msg)
          }
        }).catch(e => {
          this.isLoading = false
          this.alertError('Server error when load data. Press F5 to refresh browser')
        })
      }
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadData()
    },
    showDetail (billing) {
      axios.post(`events-billing/get-detail`, { id: billing.id }).then(response => {
        if (response.data.s === 200) {
          let data = response.data.data
          if (data.type === 'ticket') {
            this.detailTicket = {
              data: data,
              modal: true
            }
          } else {
            this.detailSponsor = {
              data: data,
              modal: true
            }
          }
        } else {
          this.alertError(response.data.msg)
        }
      }).catch(e => {
        this.alertError('Server error when load data. Press F5 to refresh browser')
      })
    }
  }
}
</script>

<style>
    #event-group .mx-datepicker {
        width: 17%;
    }

    #event-group .mx-input {
        height: 40px;
    }
</style>
<style scoped="">
    .item-select {
        width: 2% !important;
    }
    .item-date {
        width: 7% !important;
        float: left;
        min-height: 1px;
    }
    .item-type {
        width: 5% !important;
        float: left;
        min-height: 1px;
        text-align: center;
    }
    .item-bill {
        width: 10% !important;
        float: left;
        min-height: 1px;
    }
    .item-vendor {
        width: 10% !important;
        float: left;
        min-height: 1px;
    }
    .item-user {
        width: 10% !important;
        float: left;
        min-height: 1px;
    }
    .item-description {
        width: 15% !important;
        float: left;
        min-height: 1px;
    }
    .item-itemized {
        width: 15% !important;
        float: left;
        min-height: 1px;
    }
    .item-amount {
        width: 10% !important;
        float: left;
        min-height: 1px;
    }
    .item-status {
        width: 8% !important;
        float: left;
        text-align: center !important;
        min-height: 1px;
    }
    .item-payment {
        width: 8% !important;
        float: left;
        min-height: 1px;
    }
    .item-action {
        width: 5% !important;
        float: right;
        min-height: 1px;
    }
    .item-status-wheel {
        width: 10% !important;
        float: left;
        min-height: 1px;
    }
</style>
